import React from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import Portal from 'utils/portal/Portal';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import { ADMIN_DMS_READ, ADMIN_DMS_WRITE } from 'constants/rightsCodes';
import MetadataListBrowser from './MetadataListBrowser';
import PermissionCheck from 'components/common/PermissionCheck';
import { areas } from 'constants/areas';
import FlexBox from 'components/common/FlexBox';

const Route = ({ getElemByAreaKey }) => {
  return (
    <>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_DMS_WRITE} withForbiddenPage={false}>
          <FlexBox id='metadata-actions-slot' gap={0.5} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DMS_READ}>
        <MetadataListBrowser withExport={false} />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
